import { translator } from "../../../../../shop/frontend/web/js/services/TranslatorService";
import { EventFilter } from "../../../../../shop/frontend/web/js/components/EventFilter";
import { EventFilterModel } from "../../../../../shop/frontend/web/js/models/EventFilterModel";
import { DatePickerComponent } from "../../../../../shop/frontend/web/js/components/DatePickerComponent";
import { EventEmitter } from "../../../../../shop/frontend/web/js/components/EventEmitter";

class SiteController {
	constructor() {
		this.emitter = new EventEmitter();

		/* Объявляем переменные для фильтра */
		this.eventFilter = new EventFilter();
		this.filterModel = new EventFilterModel();

		/**
		 * Будет включать в себя компонент для работы с датой фильтра
		 * @module DatePickerComponent
		 */
		this.datePicker = null;
	}

	init() {
		translator.getLanguages().then(() => {
			this.setUpSubscribers();
			this.setUpListeners();

			this.initMainFilter();
			this.initMainCalendar();

			this.initToTopScrolling();
		});
	}

	setUpSubscribers() {
		/**
		 * Подписчик который применяет фильтр на афише
		 * делает запрос на сервер и возвращает res {Object} - {eventsCount, page, html}
		 * @event SiteController#event:apply-filter
		 */
		this.emitter.subscribe("event:apply-filter", (params = {}) => {
			/* по умолчанию задаем фильтрацию только для матчей (надо подумать над этим как нибудь еще) */
			if (!this.filterModel.eventTypes.length > 0) this.filterModel.eventTypes = ["match"];

			/* по умолчанию сбрасываем пагинацию страниц */
			if (params.needResetPage !== false) this.filterModel.page = 0;

			return this.filterModel.search(this.filterModel.getSearchParams()).then(res =>
				this.eventFilter.showFilteredEvents({
					...res,
					hasAnyAppliedParam: this.filterModel.hasAnyAppliedParam(),
					limit: this.filterModel.limit
				})
			);
		});
	}

	setUpListeners() {}

	initMainFilter() {
		if ($("#js-filter").attr("data-limit"))
			this.filterModel.limit = parseInt($("#js-filter").attr("data-limit"));
			
		/* Инициализация фильтрации по типам мероприятии (Матчи, Абонементы...) */
		this.eventFilter.initDropdownTypes();
		
		/* Инициализация чекбокс параметров фильтра в выпадающем списке */
		this.eventFilter.initDropdownFilters();
		this.eventFilter.on("change-dropdown-input", checkboxData => {
			if (checkboxData.isChecked) {
				this.filterModel.addItem(checkboxData);
			} else {
				this.filterModel.removeItem(checkboxData);
			}

			return this.emitter.emit("event:apply-filter");
		});

		/* Инициализация мобильного фильтра даты */
		this.eventFilter.on("setup-date-range", ({ firstDate, secondDate }) => {
			this.filterModel.setDateRange(firstDate, secondDate);

			return this.emitter.emit("event:apply-filter");
		});

		this.eventFilter.on("clear-date-range", () => {
			this.filterModel.dateRange = null;

			return this.emitter.emit("event:apply-filter");
		});

		this.eventFilter.on("reset-dropdown-filter", type => {
			this.filterModel.removeItemsByType(type);

			return this.emitter.emit("event:apply-filter");
		});

		this.eventFilter.on("click-load-more", () => {
			this.filterModel.setNextPage();

			return this.emitter.emit("event:apply-filter", { needResetPage: false });
		});

		/**
		 * Обработчик который сбрасывает фильтр
		 * @event SiteController#event:clear-filter
		 */
		this.eventFilter.on("clear-filter", () => {
			this.filterModel.clear();
			if (this.datePicker) this.datePicker.reset();

			return this.emitter.emit("event:apply-filter");
		});
	}

	initMainCalendar() {
		this.datePicker = new DatePickerComponent($(".js-datepicker-filter"));

		this.datePicker.on("apply", (ev, picker) => {
			const formatStart = picker.startDate.format("DD-MM-YYYY");
			const formatEnd = picker.endDate.format("DD-MM-YYYY");

			this.filterModel.setDateRange(formatStart, formatEnd);

			return this.emitter.emit("event:apply-filter");
		});

		/* Обработчик который сбрасывает календарь */
		this.datePicker.on("cancel", () => {
			this.filterModel.dateRange = null;
			this.datePicker.reset();

			return this.emitter.emit("event:apply-filter");
		});
	}

	initToTopScrolling() {
		const items = $("#js-index");

		if (!items.length) return false;

		const eventTop = $(".js-to-top");
		let needCorrect = 150;
		const top = items.offset().top - needCorrect;
		const screenHeight = window.screen.height;

		eventTop.on("click", () => {
			window.scrollTo({
				top,
				behavior: "smooth",
			});

			eventTop.removeClass("active");
		});

		$(document).on("scroll", () => {
			if ($(window).scrollTop() > screenHeight / 2) {
				eventTop.addClass("active");
			} else {
				eventTop.removeClass("active");
			}
		});
	}
}

const siteController = new SiteController();
siteController.init();
